import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

interface Props {
  message: string;
  subMessage?: string;
}

export const GeneralError: React.FC<Props> = props => {
  const { message, subMessage } = props;
  const { t } = useTranslationWithPrefix('generalError');

  return (
    <Stack alignItems="center" spacing={4} width="100%">
      <Typography color="error" variant="f24Medium">
        {t('wentWrong')}
      </Typography>
      <Divider />
      <Typography variant="f16Regular">
        <Box sx={{ pt: 8, textAlign: 'center' }}>{message}</Box>
        {subMessage && <Box sx={{ pt: 4, textAlign: 'center' }}>{subMessage}</Box>}
      </Typography>
    </Stack>
  );
};
